var search_util = require('../url_util/search_util.js').initBySearchString(window.location.search);

module.exports = {
	/**
	 * 判断是否为手机号
	 * @param  {number} i 要判断的手机号
	 * @param  {bool} b 手机号是否可以为空
	 * @return {bool}   是否为手机号
	 */
	phone: function (i, b) {
		if (!b) {
			b = false;
		}
		if (!i) {
			return b;
		} else {
			var phoneReg = /^1[0-9]{10}$/;
			return phoneReg.test(i);
		}
	},
	/**
	 * 判断浏览器环境是否为微信
	 * @return {[type]} [description]
	 */
	weixin: function () {
		return -1 != navigator.userAgent.toLowerCase().indexOf('micromessenger');
	},
	/**
	 * 判断浏览器环境是否为大风车app
	 * @return {[type]} [description]
	 */
	dafengche: function () {
		return -1 != navigator.userAgent.toLowerCase().indexOf('dafengche');
	},
	/**
	 * 判断浏览器环境是否为车牛 app
	 */
	cheniu: function () {
		return -1 != navigator.userAgent.toLowerCase().indexOf('cheniu');
	},
	/**
	 * 在 pc 浏览器中模拟大风车 app
	 */
	debug__dafengche: function () {
		return search_util.get('_debug_dafengche') || search_util.get('debug__dafengche');
	},
	/**
	 * 在 pc 浏览器中模拟车牛 app
	 */
	debug__cheniu: function () {
		return search_util.get('_debug_cheniu') || search_util.get('debug__cheniu');
	},
	/**
	 * 判断当前微店是否为车牛专用
	 */
	siteForCheniu: function () {
		// return window._qiwa && window._qiwa.__basic_template_id == 'template_cheniu';
		/**
		 * return window._qiwa && window._qiwa.__basic_site_default_shop && window._qiwa.__basic_site_default_shop.type == 'cheniu';
		 * 这种方案会导致判断的类型为当前选择店铺的配型，如果大风车店绑定了车牛店铺，就会导致判断出现问题
		 */
		return window._qiwa && window._qiwa.site_global.siteInitType === 'CHENIU';
	},
	/**
	 * 
	 */
	android: function () {
		return -1 != navigator.userAgent.toLowerCase().indexOf('android');
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/sc-is/is-c.js
// module id = 114
// module chunks = 4